// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2eJQH","colMaxWidth":"Table_colMaxWidth__27hk2"};